import React, { useMemo, useEffect, useCallback } from "react";
import styles from "./index.module.less";
import GlobalContext, { GlobalContextConfig } from "@/context/GlobalContext";
import bus from "@/utils/bus";
import { useHistory } from "react-router-dom";
import { sleep } from "@/utils/chat/message";
import { FocusSDK } from "@/utils";
import { getQueryByKey } from "@/utils/tools";
function LinkContainer(props: any) {
  const history = useHistory();
  const { url, appInfo } = props;
  const { focusSDK, service } = React.useContext<GlobalContextConfig>(GlobalContext);
  const webview = React.useRef<HTMLWebViewElement | null>(null);
  const preloadjs = useMemo(() => {
    return focusSDK.getInnerAppPreloadJSPath();
  }, [focusSDK]);

  const newWindowCb = React.useCallback(
   async (e: any) => {
      let applicationInfo = {
        ...appInfo
      };
      const url = new URL(e.url);
      let { protocol, host } = url;
      if (!host) {
        return;
      }
      // 优先使用url中appKey
      const appKey = getQueryByKey(e.url, "appKey");
      if (appKey) {
        try {
          const { application } = await service.appStoreService.getApplication({
            applicationKey: appKey
          }) as any;
          if (application) {
            applicationInfo = { ...application };
            console.log("tj:>>>--openweb111111111->", applicationInfo);
          }
        } catch(e) {
          console.log(`getApplication err`, e);
        }
      }
      console.log("tj:>>>--openweb22222222->", appKey, url, applicationInfo);
      // 判断 appInfo 中在工作台打开方式，默认新窗口
      if (applicationInfo?.webviewKernel) {
        history.push({ pathname: "/third_apps" });
        sleep(100).then(() => {
          const item = {
            homeUrl: e?.url,
            name: applicationInfo?.applicationName || applicationInfo?.name,
            csTelephone: "",
            omCompany: "",
            applicationKey: applicationInfo?.applicationKey,
            trustedDomains: url.hostname,
            version: applicationInfo?.pcVersion || "2.0.0",
            webviewKernel: applicationInfo?.webviewKernel || 6
          };
          console.log("tj:>>>--openThirdAppByNoticeCard->", item);
          bus.emit("openThirdAppByNoticeCard", item);
        });
      } else {
        window.open(e?.url);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [appInfo]
  );

  const handleThirdUpdate = useCallback((data: any) => {
    const eventData = JSON.stringify({ detail: { type: "update" } });
    (webview.current as any)?.executeJavaScript?.(
      `window.dispatchEvent(new CustomEvent("web-content-event", ${eventData}));`
    );
  }, []);

  const readyCb = useCallback(() => {
    FocusSDK.isBeta() && (webview.current as any)?.openDevTools?.();
  }, []);

  useEffect(() => {
    bus.on(`thirdApp:update_${appInfo?.applicationId}`, handleThirdUpdate);
    return () => {
      bus.off(`thirdApp:update_${appInfo?.applicationId}`, handleThirdUpdate);
    };
  }, [appInfo?.applicationId]);

  useEffect(() => {
    webview.current?.removeEventListener("new-window", newWindowCb);
    webview.current?.addEventListener("new-window", newWindowCb);
    webview.current?.removeEventListener("dom-ready", readyCb);
    webview.current?.addEventListener("dom-ready", readyCb);
    return () => {
      webview.current?.removeEventListener("new-window", newWindowCb);
      webview.current?.removeEventListener("dom-ready", readyCb);
    };
  }, [newWindowCb]);

  useEffect(() => {
    const fatherDiv: any = (document.getElementById("link_container") as any).parentNode;
    fatherDiv.style.height = "100%";
  }, []);
  return (
    <div id="link_container" className={styles["container"]}>
      <webview
        ref={(ref) => {
          webview.current = ref;
        }}
        id="linkcontainer"
        preload={preloadjs}
        src={url}
        className={styles["wv"]}
        webpreferences="contextIsolation=no,sandbox=false"
        plugins
        // @ts-ignore
        allowpopups="true"
      />
    </div>
  );
}
export default React.memo(LinkContainer);
